
import styles from "./PartWorkItem.module.scss";
import { useState } from "react";
import { useTranslation } from 'react-i18next';

import checkicon from 'assets/icons/check.png'
import circleicon from 'assets/icons/circle.png'
import squareicon from 'assets/icons/square.png'
import checksquareicon from 'assets/icons/square_check.png'
import pieeeeechart from 'assets/icons/pieeeeechart.png'
import Notification from "utils/Notifications";

import { removeAnswer, moveAnswerUp, moveAnswerDown } from "service/TestService";
import { EditorState, convertFromRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";

const PartWorkItem = ({ item, index, setRender, MassLength, ChangeRowOn }) => {
    const { t } = useTranslation('common');

    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });


    const DraftContent = ({ draftData }) => {
        let contentState;
        try {
            const parsedData = typeof draftData === "string" ? JSON.parse(draftData) : draftData;
            contentState = convertFromRaw(parsedData);
            
            if  (!parsedData?.blocks[0]?.text) {
                return null
            
            }
        } catch (error) {
            return <p>Invalid content format</p>;
        }

        const editorState = EditorState.createWithContent(contentState);

        return (
            <div st>
                <Editor editorState={editorState} readOnly toolbarHidden />
            </div>
        );
    };

    const removeRow = (id) => {
        try {
            removeAnswer(id);
            setNotify({
                isOpen: true,
                message: t('tests.data_sent_success'),
                type: "success",
            });
            setRender(true);
        } catch (error) {
            setNotify({
                isOpen: true,
                message: t('tests.data_send_error'),
                type: "error",
            });
        }
    };
    const moveRowUp = (id) => {
        try {
            moveAnswerUp(id);
            setNotify({
                isOpen: true,
                message: t('tests.data_sent_success'),
                type: "success",
            });
            setRender(true);
        } catch (error) {
            setNotify({
                isOpen: true,
                message: t('tests.data_send_error'),
                type: "error",
            });
        }

    };
    const moveRowDown = (id) => {
        try {
            moveAnswerDown(id);
            setNotify({
                isOpen: true,
                message: t('tests.data_sent_success'),
                type: "success",
            });
            setRender(true);
        } catch (error) {
            setNotify({
                isOpen: true,
                message: t('tests.data_send_error'),
                type: "error",
            });
        }
    };
    const [text, setText] = useState('');
    const maxLength = 1000;  

    const handleChange = (event) => {
        setText(event.target.value);
    };

    const [file, setFile] = useState(null);

    const handleFileChange_test = (e) => {
        setFile(e.target.files[0]);
    };

    return (

        <div className={styles.answer_card_selection}>
            <div className={styles.answer_card_selection_header}>

                {item.type_answer === 'singleSelection' && <h3>{t('tests.builder.qtype_single')}</h3>}
                {item.type_answer === 'multipleSelection' && <h3>{t('tests.builder.qtype_multiple')}</h3>}
                {item.type_answer === 'numericInput' && <h3>{t('tests.builder.qtype_numeric')}</h3>}
                {item.type_answer === 'textInput' && <h3>{t('tests.builder.qtype_text')}</h3>}
                {item.type_answer === 'freeTextAnswer' && <h3>{t('tests.builder.qtype_free')}</h3>}
                {item.type_answer === 'sequenceOrdering' && <h3>{t('tests.builder.qtype_sequence')}</h3>}
                {item.type_answer === 'slider' && <h3>{t('tests.builder.qtype_slider')}</h3>}
                {item.type_answer === 'fileUpload' && <h3>{t('tests.builder.qtype_file')}</h3>}
                {item.type_answer === 'infoText' && <h3>{t('tests.builder.qtype_info')}</h3>}

                <h2 className={styles.answer_card_selection_header_h2} key={index}>
                    <span>
                        <img
                            src={pieeeeechart}
                            className={styles.img}
                            alt='sdfsd'
                        />

                        {Math.max(
                            item.max_points_for_the_correct_answer,
                            item.points_for_the_correct_answer,
                            item.points_for_the_wrong_answer,
                            ...item.answer_part_worktest.map(answer => answer.points)
                        )}
                    </span>
                    <span>
                        {item.part_number}/{MassLength}</span></h2>
            </div>
            {item.image &&
                <img
                    src={item.image}
                    className={styles.img_file}
                />
            }
            <div className={styles.answer_card_selection_body}>

                <DraftContent draftData={item.body} />
                <div className={styles.answer_card_selection_body_answer}>
                    {item.answer_part_worktest.map((answer, index) => (
                        <div style={{ width: '100%' }}>
                            {(item.type_answer !== "freeTextAnswer" && item.type_answer !== "infoText" && item.type_answer !== 'fileUpload') ? (
                                <div className={styles.answer_card_header}>

                                    {(item.checkpoints === true && item.type_answer !== 'numericInput' && item.type_answer !== 'textInput' && item.type_answer !== "slider" && item.type_answer !== 'sequenceOrdering') &&
                                        <img
                                            src={answer.points > 0 ? checkicon : circleicon}
                                            className={styles.img}
                                        />
                                    }

                                    {(item.checkpoints === false && item.type_answer !== 'numericInput' && item.type_answer !== 'textInput' && item.type_answer !== "slider" && item.type_answer !== 'sequenceOrdering') &&
                                        <img
                                            src={answer.right_answer === true ? checksquareicon : squareicon}
                                            className={styles.img}
                                        />
                                    }
                                    {(item.type_answer === 'sequenceOrdering') &&
                                        <>
                                            <DraftContent draftData={answer.title} />
                                            <select
                                                className={styles.point_check_num_text}
                                                value={answer.sequences_selectedNumber}  

                                            >
                                                <option value={answer.sequences_selectedNumber}>{answer.sequences_selectedNumber}</option>
                                            </select>
                                        </>
                                    }
                                    {(item.type_answer === 'slider') &&
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: "5px" }}>
                                            <div>
                                                <h4 >{answer.type_input_txt}</h4>

                                            </div>
                                            <div className={styles.slider_min_max}>
                                                <h4>{Math.min(Number(answer.min_len), Number(answer.max_len))}</h4>
                                                <input
                                                    id="slider"
                                                    type="range"
                                                    min={Math.min(Number(answer.min_len), Number(answer.max_len))}
                                                    max={Math.max(Number(answer.min_len), Number(answer.max_len))}
                                                    value={answer.ranswer}
                                                    style={{ width: '100%' }}
                                                />
                                                <h4>{Math.max(Number(answer.min_len), Number(answer.max_len))}</h4>
                                                <h4 className={styles.slider_right_answer}> <img
                                                    src={checksquareicon}
                                                    className={styles.img}
                                                />{answer.ranswer}</h4>
                                            </div>
                                        </div>
                                    }
                                    {(item.type_answer === 'numericInput') &&
                                        <h4 style={{ border: '1px solid rgb(41, 33, 33)', padding: '5px 10px' }}>{answer.type_input_int}</h4>
                                    }
                                    {(item.type_answer === 'textInput') &&
                                        <h4 style={{ border: '1px solid rgb(123, 123, 123)', padding: '5px 10px' }}>{answer.type_input_txt}</h4>
                                    }
                                    {(item.type_answer === 'singleSelection' || item.type_answer === 'multipleSelection') &&
                                        <DraftContent draftData={answer.title} />
                                    }
                                </div>
                            ) : (
                                <>
                                    {item.type_answer === "freeTextAnswer" && (
                                        <div className={styles.answer_card_header}>
                                            <div className={styles.answer_card_second_div} >
                                                <textarea
                                                    value={text}
                                                    className={styles.answer_card_header_textarea}
                                                    onChange={handleChange}
                                                    maxLength={item.max_len}
                                                    rows="4"
                                                    cols="50"
                                                    placeholder={t('tests.builder.test_print_ph')}
                                                />
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }}>
                                                    <span>{text.length} / {item.max_len}</span>
                                                </div>
                                            </div>
                                        </div>

                                    )}
                                    {item.type_answer === "fileUpload" && (
                                        <div className={styles.answer_card_header}>
                                            <div className={styles.answer_card_second_div} >
                                                <input
                                                    type="file"
                                                    id="file-upload"
                                                    className={styles.file_upload_input}
                                                    onChange={handleFileChange_test}  
                                                />
                                                <label htmlFor="file-upload" className={styles.file_upload_label}>
                                                    {file ? file.name : t('tests.builder.upload_file_btn')}
                                                </label>
                                            </div>
                                        </div>
                                    )}

                                </>
                            )}
                            {answer.file &&
                                <img
                                    src={answer.file}
                                    className={styles.img_file}
                                />
                            }
                        </div>
                    ))}
                </div>
                {item?.comment !== null &&
                    <div style={{ marginTop: '40px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                        

                        <DraftContent draftData={item.comment} />

                    </div>
                }

            </div>
            <div className={styles.answer_card_selection_footer}>

                {item.part_number > 1 && (
                    <button
                        onClick={() => moveRowUp(item.id)}
                        style={{
                            padding: "10px 16px",
                            backgroundColor: "#27ae60",
                            color: "#fff",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontWeight: "600",
                            fontSize: "14px",
                            fontFamily: "var(--font-base, Inter, sans-serif)",
                            transition: "all 0.2s ease"
                        }}
                    >
                        ↑
                    </button>
                )}

                {item.part_number < MassLength && (
                    <button
                        onClick={() => moveRowDown(item.id)}
                        style={{
                            padding: "10px 16px",
                            backgroundColor: "#f39c12",
                            color: "#fff",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontWeight: "600",
                            fontSize: "14px",
                            fontFamily: "var(--font-base, Inter, sans-serif)",
                            transition: "all 0.2s ease"
                        }}
                    >
                        ↓
                    </button>
                )}

                <button
                    style={{
                        padding: "10px 16px",
                        fontSize: "14px",
                        color: "#fff",
                        border: "none",
                        background: "#3498db",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontWeight: "600",
                        fontFamily: "var(--font-base, Inter, sans-serif)",
                        transition: "all 0.2s ease"
                    }}
                    onClick={() => ChangeRowOn(item.id)}
                >
                    {t('common.edit')}
                </button>

                <button
                    onClick={() => removeRow(item.id)}
                    style={{
                        padding: "10px 16px",
                        backgroundColor: "#e74c3c",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontWeight: "600",
                        fontSize: "14px",
                        fontFamily: "var(--font-base, Inter, sans-serif)",
                        transition: "all 0.2s ease"
                    }}
                >
                    {t('common.delete')}
                </button>
            </div>
            <hr></hr>
            <Notification notify={notify} setNotify={setNotify} />
        </div >


    );
};

export default PartWorkItem;
